import React from "react";
import PropTypes from "prop-types";
import "../../../assets/scss/general.scss";

const BubbleInfoSection = ({ title, info, investment }) => {
  return (
    <div
      style={{
        width: "25%",
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        justifyContent: "flex-start",
        paddingTop: "10px",
      }}
    >
      {investment !== false && info && (
        <div className="bubbleInvestmentInfo">
          <h2>{title}</h2>
          <h3 style={{color: "#F7776E", fontWeight: 400 }}>
            {investment}
          </h3>
          <div>
            {info.map((bubble, index) => (
              <p key={index} style={{ fontSize: "18px" }}>
                {bubble.text}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

BubbleInfoSection.propTypes = {
  info: PropTypes.string,
  investment: PropTypes.string,
  title: PropTypes.string,
};

export default BubbleInfoSection;
